import React from "react";

import TagMeetingHeader from "../components/TagMeetingHeader";
import ProfileFormComponent from "../components/ProfileFormComponent";

const ProfilePage = () => {
  return (
    <>
      <TagMeetingHeader headerName="Profile" />
      <ProfileFormComponent />
    </>
  );
};

export default ProfilePage;
